"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizedGasWeb3Provider = exports.CustomizedGasJsonRpcSigner = void 0;
const providers_1 = require("@ethersproject/providers");
const _constructorGuard = {};
class CustomizedGasJsonRpcSigner extends providers_1.JsonRpcSigner {
}
exports.CustomizedGasJsonRpcSigner = CustomizedGasJsonRpcSigner;
class CustomizedGasWeb3Provider extends providers_1.Web3Provider {
    constructor(gasFeeMultiplier, provider, network) {
        super(provider, network);
        this.customizedGasFeeContracts = [];
        this.gasFeeMultiplier = gasFeeMultiplier;
    }
    addCustomizedGasFeeContract(...contractAddress) {
        this.customizedGasFeeContracts.push(...contractAddress);
    }
    async estimateGas(transaction) {
        const toAddress = await transaction.to;
        if (!toAddress) {
            // if to is undefined, it's a contract creation transaction
            // fallback to parent class
            return super.estimateGas(transaction);
        }
        if (this.customizedGasFeeContracts.includes(toAddress)) {
            // console.log(`estimateGas for customized gas fee contract ${toAddress}`);
            const gasLimit = await super.estimateGas(transaction);
            // console.log(`!!!estimateGas: ${gasLimit}`);
            return gasLimit.mul(1000 * this.gasFeeMultiplier).div(1000);
        }
        else {
            // console.log(`estimateGas for normal contract ${toAddress}`);
            return super.estimateGas(transaction);
        }
    }
}
exports.CustomizedGasWeb3Provider = CustomizedGasWeb3Provider;
//# sourceMappingURL=customized-gas-web3-provider.js.map